import { Navigate, useOutletContext } from "react-router-dom";

export default function IndexRoute() {
  const { allowedLocations } = useOutletContext();

  return (
    <Navigate
      to={`/${allowedLocations[0]}`}
      replace
    />
  );
}
